import { getAPIUrl } from '../global';
import { Get, Post, Put, Remove } from '../headerIntercepter';

export const createQuestion = (data,params) => {
  const url = getAPIUrl('organization.question.create',params);
  return Post(url, data, true);
};

export const getQuestion = (params={},query={}) => {
    const url = getAPIUrl('organization.question.self',params);
    return Get(url, true,query);
  };

export const getQuestionById = (params={}) => {
  const url = getAPIUrl('organization.question.id',params);
  return Get(url, true,{});
};

export const UpdateQuestionById = (data,params={}) => {
  const url = getAPIUrl('organization.question.id',params);
  return Post(url, data,{});
};
export const deleteQuestionById = (params={}) => {
  const url = getAPIUrl('organization.question.id',params);
  return Remove(url, true);
};